import { useFeatureFlag } from '@order/LaunchDarkly';

export const useRedesignedOrderingFlow = () => {
  return useFeatureFlag('CELS-2627-order-ordering-redesign-enabled');
};
